import { initializeApp } from "firebase/app";
const {
  initializeAppCheck,
  ReCaptchaV3Provider,
} = require("firebase/app-check");

const firebaseConfig = {
  apiKey: "AIzaSyDVvXQzdwfEc2hUXFfmhDM6q4zTdbCrC7g",
  authDomain: "passcrate.firebaseapp.com",
  projectId: "passcrate",
  storageBucket: "passcrate.appspot.com",
  messagingSenderId: "825907711799",
  appId: "1:825907711799:web:04b9d5ae01af2a469854b2",
  measurementId: "G-F4V350V2G7",
};

const app = initializeApp(firebaseConfig);

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6Le8vdUgAAAAAIUMA9sx4x06WmvW_42vE6atG1tV"),
  isTokenAutoRefreshEnabled: true,
});

export default app;
